<mat-card>
    <mat-card-header>
        <mat-card-title>Current Model Composition</mat-card-title>
        <mat-form-field class="ms-auto text-small" appearance="outline">
            <mat-label>Limit</mat-label>
            <mat-select [(ngModel)]="selectedLimit" (ngModelChange)="onLimitChange()">
                <mat-option *ngFor="let limit of listLimits" [value]="limit.id">{{limit.name}}</mat-option>
            </mat-select>
        </mat-form-field>
    </mat-card-header>
    <mat-card-content>
        <table mat-table [dataSource]="dataSource" matSort class="w-100">

            <ng-container matColumnDef="rank">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Rank</th>
                <td mat-cell *matCellDef="let element" class="text-start">
                    <span class="badge badge-pill rank-badge bg-primary">{{element.rank}}</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Company Name</th>
                <td mat-cell *matCellDef="let element">
                    {{element.name}}
                    <app-popover [company]="element" (click)="closeOtherCompanies(element)"></app-popover>
                </td>
            </ng-container>
            <ng-container matColumnDef="sector">
                <th mat-header-cell *matHeaderCellDef>Sector</th>
                <td mat-cell *matCellDef="let element"> {{element.sector ? element.sector.name : ''}} </td>
            </ng-container>
            <ng-container matColumnDef="market">
                <th mat-header-cell *matHeaderCellDef>Headquarter</th>
                <td mat-cell *matCellDef="let element"> {{element.market ? element.market.name : ''}} </td>
            </ng-container>
            <ng-container matColumnDef="frequency">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Frequency <mat-icon class="ms-1" matTooltip="Percentage of observations in backtest">info</mat-icon></th>
                <td mat-cell *matCellDef="let element" class="text-end"> {{element.frequency ? ((element.frequency*100|number) + '%') : ''}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </mat-card-content>
</mat-card>

